<div *ngIf="isMockRolesEnabled" class="alert alert-warning" role="alert" translate>
  MOCK_ROLES_ENABLED
</div>